export const storePlantRowData = (data) => ({
  type: "STORE_PLANT_ROW_DATA",
  payload: data,
});
export const storeAccessUserPlant = (data) => ({
  type: "STORE_ACCESS_USER_PLANT",
  payload: data,
});
export const storeCompanyName = (data) => ({
  type: "STORE_COMPANY_NAME",
  payload: data,
});
export const storeXlsData = (data) => ({
  type: "STORE_XLS_DATA",
  payload: data,
});

export const storeToken = (data) => ({
  type: "STORE_TOKEN",
  payload: data,
});

export const storeUsername = (data) => ({
  type: "STORE_USERNAME",
  payload: data,
});
export const storeUserEmail = (data) => ({
  type: "STORE_USEREMAIL",
  payload: data,
});
export const storePlantData = (data) => ({
  type: "STORE_PLANT_DATA",
  payload: data,
});
export const storeUserDetails = (data) => ({
  type: "STORE_USERDETAILS",
  payload: data,
});
export const storeUserProfileData = (data) => ({
  type: "STORE_USER_PROFILE_DATA",
  payload: data,
});
export const storeuserRole = (data) => ({
  type: "STORE_USERROLE",
  payload: data,
});
export const storeRequestStatus = (data) => ({
  type: "STORE_REQUEST_STATUS",
  payload: data,
});
export const storeDigital = (data) => ({
  type: "STORE_DIGITAL",
  payload: data,
});

export const storeFileId = (data) => ({
  type: "STORE_FILE_ID",
  payload: data,
});

export const storeFileSheetMapping = (data) => ({
  type: "STORE_FILE_SHEET_MAPPING",
  payload: data,
});

export const storePlantDetails = (data) => ({
  type: "STORE_PLANT_DETAILS",
  payload: data,
});

export const storeDefaultInformation = (data) => ({
  type: "STORE_DEFAULT_DETAILS",
  payload: data,
});
export const storeSettingsDefaults = (data) => ({
  type: "STORE_SETTINGS_DEFAULTS",
  payload: data,
});
export const storeSuggestedSettings = (data) => ({
  type: "STORE_SUGGESTED_SETTINGS",
  payload: data,
});
export const storeReplacementThreshold = (data) => ({
  type: "STORE_REPLACEMENT_THRESHOLD",
  payload: data,
});

export const storeCIPS = (data) => ({
  type: "STORE_CIPS",
  payload: data,
});

export const storeCleanData = (data) => ({
  type: "STORE_CLEAN_DATA",
  payload: data,
});

export const storeUnits = (data) => ({
  type: "STORE_UNITS",
  payload: data,
});

export const storeClenaingEffectiness = (data) => ({
  type: "STORE_CLEANING_EFFECTIVNESS",
  payload: data,
});

export const storeFouling = (data) => ({
  type: "STORE_FOULING",
  payload: data,
});

export const storeFoulingType = (data) => ({
  type: "STORE_FOULING_TYPE",
  payload: data,
});

export const storePredictionData = (data) => ({
  type: "STORE_PREDICTION_DATA",
  payload: data,
});

export const storeForcastWindow = (data) => ({
  type: "STORE_FORECAST_WINDOW",
  payload: data,
});

export const storeReplacementForecastWindow = (data) => ({
  type: "STORE_REPLACEMENT_FORECAST_WINDOW",
  payload: data,
});

export const storeNoTrains = (data) => ({
  type: "STORE_NO_OF_TRAINS",
  payload: data,
});

export const storeSelectedValues = (data) => ({
  type: "STORE_SELECTED_VALUES",
  payload: data,
});

export const cleanData = (data) => ({
  type: "CLEAR_DATA",
  payload: data,
});

export const storeAppLanguage = (data) => ({
  type: "STORE_APP_LANGUAGE",
  payload: data,
});

export const updateSelectedTrain = (data) => ({
  type: "SEL_SELECTED_TRAIN",
  payload: data,
});
export const storeAnalysisData = (data) => ({
  type: "STORE_ANALYSIS_DATA",
  payload: data,
});

export const storeTaskId = (data) => ({
  type: "STORE_TASK_ID",
  payload: data,
});

// remove this action if not needed
export const storeCATaskId = (data) => ({
  type: "STORE_CA_TASK_ID",
  payload: data,
});

export const storeClenaingEffectinessThreshold = (data) => ({
  type: "STORE_CLEANING_EFFECTIVNESS_THRESHOLD",
  payload: data,
});

export const storeAdvancedSettings = (data) => ({
  type: "STORE_ADVANCED_SETTINGS",
  payload: data,
});

export const resetAdvancedSettings = () => ({
  type: "RESET_ADVANCED_SETTINGS",
});

export const storeUserChemicalLibrary = (data) => ({
  type: "STORE_USER_CHEMICAL_LIBRARY",
  payload: data,
});

export const storePlantChemicalLibrary = (data) => ({
  type: "STORE_PLANT_CHEMICAL_LIBRARY",
  payload: data,
});

export const storePlantUtilityCosts = (data) => ({
  type: "STORE_PLANT_UTILITY_COSTS",
  payload: data,
});

export const storeTrainUtilityCosts = (data) => ({
  type: "STORE_TRAIN_UTILITY_COSTS",
  payload: data,
});

export const storeTrainChemicalSelection = (data) => ({
  type: "STORE_TRAIN_CHEMICAL_SELECTION",
  payload: data,
});

export const storeLicensePermissions = (data) => ({
  type: "STORE_LICENSE_PERMISSIONS",
  payload: data,
});

export const storeGlobalApiErrorCode = (data) => ({
  type: "STORE_GLOBAL_API_ERROR_CODE",
  payload: data,
});

export const clearAuthSession = () => ({
  type: "CLEAR_AUTH_SESSION",
});
